export default __webpack_public_path__ + "static/media/scale-new.f5bb5081.svg";